import { render, staticRenderFns } from "./DiscountCard.vue?vue&type=template&id=3686de2d"
import script from "./DiscountCard.vue?vue&type=script&lang=js"
export * from "./DiscountCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports